@if(loading===false){
@if(isHIP) {
<mat-expansion-panel class="content-holder">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Export & Retrieve backup files
        </mat-panel-title>
    </mat-expansion-panel-header>
    <h3>Generate backup file</h3>
    <button class="gen-button" mat-raised-button (click)="generateBackupFile()">Generate</button>

    <tools-table class="audit-table" [Headers]="backupFilesHeaders" [ExtraQuery]="'?filetype=backup'+opn"
        [Actions]="backupTableActions" [Search]="false" [ApiPath]="generatedFilesUrl" [HTTPPost]="false"></tools-table>
</mat-expansion-panel>

<mat-expansion-panel class="content-holder">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Upload Config File
        </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
        <mat-form-field class="file-name-input">
            <mat-label>File Name</mat-label>
            <input matInput type="text" [formControlName]="'fileNameControl'" placeholder="Upload Config File">
            @if(form.controls['fileNameControl'].errors && form.controls['fileNameControl'].hasError('required') &&
            isFileUploaded!=null){
            <mat-error>Enter a name</mat-error>
            }
        </mat-form-field>
        @if(files==null||files.length===0){
        <div class="uploadfilecontainer" (click)="fileInput.click()" appDragNDrop
            (onFileDropped)="handleDroppedFiles($event);">
            <input hidden type="file" id="fileInput" #fileInput
                (change)="onFileInput($event.target ? $event.target['files'] : null)" multiple>
            Drag or Click to Upload
        </div>

        <p class="uploadHelp">What file types are allowed? <mat-icon class="pointer"
                matTooltip="tar.gz files are allowed">
                contact_support</mat-icon>
        </p>
        }@else {
        <div>
            <p>Selected File:</p>
            <div class="files-list">
                <p style="width: 100%;"> {{ files[0].name }} @if (!working) {
                    <span class="material-icons delete-icon" (click)="deleteFile()">delete_forever</span>
                    }
                </p>
            </div>

        </div>
        <div>
            <mat-checkbox [formControlName]="'confirmed'" color="primary">
                I confirm that the config has been tested and is working correctly
            </mat-checkbox>
            <button mat-raised-button [disabled]="!form.get('confirmed')?.value" (click)="upload();"><span
                    class="material-icons">cloud_upload</span>Upload and Apply
                File</button>
        </div>
        }

    </form>
</mat-expansion-panel>

<mat-expansion-panel class="content-holder">
    <mat-expansion-panel-header>
        @if(isHIP){
        <mat-panel-title>
            Select and Apply Config File
        </mat-panel-title>
        } @else {
        <mat-panel-title>
            Config Files
        </mat-panel-title>
        }
    </mat-expansion-panel-header>
    <tools-table class="config-table" [Headers]="configFilesHeaders" [Actions]="configFilesActions" [Search]="false"
        [ApiPath]="configFilesUrl" [HTTPPost]="false"></tools-table>
</mat-expansion-panel>
<mat-expansion-panel class="content-holder">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Send SMS Message
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="sms-container">
        <mat-form-field style="width: 80%;">
            <mat-label>SMS Message</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" #autosize="cdkTextareaAutosize" type="text"
                [(ngModel)]="smsMessage"> </textarea>
        </mat-form-field>
        <button mat-raised-button (click)="sendSMS('active')">Send SMS To Active SIM</button>
        <button mat-raised-button (click)="sendSMS('inactive')">Send SMS To Inactive SIM</button>
        <button mat-raised-button (click)="sendSMSWithConfirmation('both')">Send SMS To Both SIMs</button>
    </div>
</mat-expansion-panel>
<mat-expansion-panel class="content-holder" (opened)="wanDataSchedulingOpened()">
    <mat-expansion-panel-header>
        <mat-panel-title>
            WAN Data Scheduling
        </mat-panel-title>
    </mat-expansion-panel-header>
    @if(wanLoading){
    <mat-spinner [diameter]="40"></mat-spinner>
    }@else{
    <form [formGroup]="wanForm" class="wan-container">
        <div class="wan-form-field">
            <mat-label>Enabled</mat-label>
            <div class="wan-input">
                <mat-slide-toggle formControlName="enabled">
                    {{ wanForm.get('enabled')?.value ? 'On' : 'Off' }}
                </mat-slide-toggle>
            </div>
        </div>
        <div class="wan-form-field">
            <mat-label>Interval</mat-label>
            <div class="wan-input">
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <input type="number" [min]="60" matInput formControlName="interval">
                    <span matTextSuffix>Seconds</span>
                    @if (wanForm.get('interval')?.hasError('required')) {
                    <mat-error>Interval is required</mat-error>
                    } @else if (wanForm.get('interval')?.hasError('min')) {
                    <mat-error>Interval must be at least 60 seconds</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        <button class="wan-button" mat-raised-button (click)="saveWANScheduler()"
            [disabled]="wanForm.invalid">Save</button>
    </form>
    }
</mat-expansion-panel>

<mat-expansion-panel class="content-holder">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Select and Apply Firmware File
        </mat-panel-title>

    </mat-expansion-panel-header>
    @if (applyFirmwareLoading){
    <mat-spinner [diameter]="40"></mat-spinner>
    }@else{
    <tools-table class="config-table" [Headers]="firmwareFileHeaders" [Actions]="firmwareFileActions" [Search]="false"
        [ApiPath]="firmwareFilesURL" [HTTPPost]="false"></tools-table>
    }
</mat-expansion-panel>

}
<mat-expansion-panel class="content-holder" (opened)="snmpAgentOpened()">
    <mat-expansion-panel-header>
        <mat-panel-title>
            SNMP Settings Configuration
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="snmp-settings-container">
        @if(snmpAgentLoading){
        <mat-spinner [diameter]="40"></mat-spinner>
        } @else if (!snmpAgentLoading && snmpAgentError != null) {
        @if (snmpAgentError.includes("SNMP agent settings response HTTP code is not 200")) {
        <div class="snmp-agent-unavailable">
            <p>SNMP package is not installed on this device.</p>
            <p>Please install the package and try again.</p>
        </div>
        } @else {
        <div class="snmp-agent-error">
            <p>Error getting SNMP Agent details.</p>
        </div>
        }
        } @else{
        <form class="snmp-container" [formGroup]="snmpSettingsForm">
            <div class="snmp-form-field">
                <mat-label>Enable SNMP</mat-label>
                <div class="snmp-input">
                    <mat-slide-toggle formControlName="enabled">
                        {{ snmpSettingsForm.get('enabled')?.value ? 'On' : 'Off' }}
                    </mat-slide-toggle>
                </div>
            </div>
            <div class="snmp-form-field">
                <mat-label>Enable Remote Access</mat-label>
                <div class="snmp-input">
                    <mat-slide-toggle formControlName="remoteAccess">
                        {{ snmpSettingsForm.get('remoteAccess')?.value ? 'On' : 'Off' }}
                    </mat-slide-toggle>
                </div>
            </div>
            <div class="snmp-form-field">
                <mat-label>IP Type</mat-label>
                <div class="snmp-input">
                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <mat-select formControlName="ipType">
                            <mat-option value="ipv4">IPv4</mat-option>
                            <mat-option value="ipv6">IPv6</mat-option>
                            <mat-option value="ipv4v6">IPv4 and IPv6</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="snmp-form-field">
                <mat-label>Port</mat-label>
                <div class="snmp-input">
                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <input matInput type="number" placeholder="1-65535" formControlName="port">
                        @if(snmpSettingsForm.get('port')?.errors && snmpSettingsForm.get('port')?.hasError('required')){
                        <mat-error>Port is required</mat-error>
                        }@else if(snmpSettingsForm.get('port')?.errors &&
                        (snmpSettingsForm.get('port')?.hasError('min')||
                        snmpSettingsForm.get('port')?.hasError('max'))){
                        <mat-error>Port must be between 1 and 65535</mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
            <div class="snmp-form-field">
                <mat-label>SNMP v1 Mode</mat-label>
                <div class="snmp-input">
                    <mat-slide-toggle formControlName="v1Mode">
                        {{ snmpSettingsForm.get('v1Mode')?.value ? 'On' : 'Off' }}
                    </mat-slide-toggle>
                </div>
            </div>
            <div class="snmp-form-field">
                <mat-label>SNMP v2c Mode</mat-label>
                <div class="snmp-input">
                    <mat-slide-toggle formControlName="v2cMode">
                        {{ snmpSettingsForm.get('v2cMode')?.value ? 'On' : 'Off' }}
                    </mat-slide-toggle>
                </div>
            </div>
            <div class="snmp-form-field">
                <mat-label>SNMP v3 Mode</mat-label>
                <div class="snmp-input">
                    <mat-slide-toggle formControlName="v3Mode">
                        {{ snmpSettingsForm.get('v3Mode')?.value ? 'On' : 'Off' }}
                    </mat-slide-toggle>
                </div>
            </div>
        </form>
        <button class="save-button" mat-raised-button (click)="saveSNMPSettings()"
            [disabled]="snmpSettingsForm.invalid">Save</button>
        }
    </div>
</mat-expansion-panel>
<mat-expansion-panel class="content-holder" (opened)="snmpGeneralOpened()">
    <mat-expansion-panel-header>
        <mat-panel-title>
            SNMP General Configuration
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="snmp-settings-container">
        @if(snmpGeneralLoading){
        <mat-spinner [diameter]="40"></mat-spinner>
        } @else if (!snmpGeneralLoading && snmpGeneralError != null) {
        @if (snmpGeneralError.includes("SNMP general settings response HTTP code is not 200")) {
        <div class="snmp-agent-unavailable">
            <p>SNMP package is not installed on this device.</p>
            <p>Please install the package and try again.</p>
        </div>
        } @else {
        <div class="snmp-agent-error">
            <p>Error getting SNMP General details.</p>
        </div>
        }
        } @else{
        <form class="snmp-container" [formGroup]="snmpGeneralForm">
            <div class="snmp-form-field">
                <mat-label>Location</mat-label>
                <div class="snmp-input">
                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <input matInput formControlName="location">
                    </mat-form-field>
                </div>
            </div>
            <div class="snmp-form-field">
                <mat-label>Contact</mat-label>
                <div class="snmp-input">
                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <input matInput formControlName="contact">
                    </mat-form-field>
                </div>
            </div>
            <div class="snmp-form-field">
                <mat-label>Name</mat-label>
                <div class="snmp-input">
                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <input matInput formControlName="name">
                    </mat-form-field>
                </div>
            </div>
        </form>
        <button class="save-button" mat-raised-button (click)="saveSNMPGeneralSettings()"
            [disabled]="snmpGeneralForm.invalid">Save</button>
        }
    </div>
</mat-expansion-panel>
<mat-expansion-panel class="content-holder" (opened)="snmpUsersOpened()">
    <mat-expansion-panel-header>
        <mat-panel-title>
            SNMP User Configuration
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="snmp-settings-container">
        @if(snmpUserLoading){
        <mat-spinner [diameter]="40"></mat-spinner>
        } @else if (!snmpGeneralLoading && snmpGeneralError != null) {
        @if (snmpGeneralError.includes("SNMP general settings response HTTP code is not 200")) {
        <div class="snmp-agent-unavailable">
            <p>SNMP package is not installed on this device.</p>
            <p>Please install the package and try again.</p>
        </div>
        } @else {
        <div class="snmp-agent-error">
            <p>Error getting SNMP User details.</p>
        </div>
        }
        } @else{
        <div class="snmp-user-container">
            @for(user of snmpUsers; track user){
            <mat-card>
                <mat-card-header>
                    <div class="snmp-user-header">
                        <mat-card-title style="overflow:hidden; text-overflow: ellipsis; white-space: nowrap;">
                            User {{user.ID}}
                        </mat-card-title>
                        <button mat-icon-button (click)="editSNMPUser(user)">
                            <mat-icon>edit</mat-icon>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <p>Enabled: {{user.Enabled ? 'Yes' : 'No'}}</p>
                    <p>Username: {{user.Username}}</p>
                    <p>Access Mode: {{user.Rights}}</p>
                    <p>Security Level: {{user.SecLevel}}</p>
                    <p>Authentication Type: {{user.AuthType}}</p>
                </mat-card-content>
            </mat-card>
            }
            <button mat-icon-button (click)="addSNMPUser()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        }
    </div>
</mat-expansion-panel>
}@else{
<mat-spinner [diameter]="40"></mat-spinner>
}

<div style="margin-top: 20px"></div>